exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_option_MZzFyJDSVIvcu2NmOkmfL {\n  width: 100%;\n  height: 30px;\n}\n\n.IA_icon_2LdYsF9drIS-BODG-JmeOW {\n  float: left;\n}\n\n.IA_label_3pOS7pGZLF0HSucnBoWv-f {\n  float: left;\n  margin-left: 10px;\n  line-height: 30px;\n}", ""]);

// Exports
exports.locals = {
	"IA_option": "IA_option_MZzFyJDSVIvcu2NmOkmfL",
	"IA_icon": "IA_icon_2LdYsF9drIS-BODG-JmeOW",
	"IA_label": "IA_label_3pOS7pGZLF0HSucnBoWv-f"
};